import React, { useEffect, useState } from 'react'
import Loader from '../../../../Helper/Loader'
import { useLocation, useNavigate } from 'react-router-dom';
import { useStartNewQuizMutation } from '../../../../API/StartQuizQApi';
import apiResponse from '../../../../Interfaces/apiResponse';
import { toast } from 'react-toastify';
import { quizModel } from '../../../../Interfaces/quizModel';


interface Props {
    isOpen: boolean; 
    closeModal: () => void; 
    gUserId:string;
  }
function ConfirmModal({ isOpen, closeModal,gUserId }: Props) {
const [loading, setLoading] =useState(false);
const navigate = useNavigate();
const [newQuiz] = useStartNewQuizMutation();
const [input, setInput] = useState({
    userId : gUserId,
    dateTaken : Date.now,
    dateEnd : Date.now,
    quizLevel:0,
    questionItems:0,
});
const handleUserInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
  const { name, value } = e.target;
  let processedValue: any = value;
  setInput((prev) => ({
    ...prev,
    [name]: processedValue
  }));
};
const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) =>{
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
    const response:apiResponse = await newQuiz(input);
     if(response.data?.isSuccess == true){
     
        const modal = document.getElementById('exampleModalAddEmp');
        if (modal) {
            toast.success('Started the test Successfully!', {
                position: "top-right", 
                autoClose: 5000, 
              });

            closeModal();
             navigate("/startquiz/new",{ state: { quizQuestionResult : response.data?.result } });
        }        
        
        }else if(response.data?.exist == true){
          toast.error('Employee already exist!', {
            position: "top-right", 
            autoClose: 5000, 
          });
        }
        else{
          toast.error('Something went wrong!', {
              position: "top-right", 
              autoClose: 5000, 
            });
        }
      
    } catch (error) {
      console.error('Error:', error);
     
    } finally {
      setLoading(false);
    }
   
    setLoading(false);
}


    useEffect(() => {
      if (isOpen) {
        // Manually trigger modal to open
        const modal = document.getElementById('exampleModalAddEmp');
        if (modal) {
          modal.classList.add('show');
          modal.style.display = 'block';
          document.body.classList.add('modal-open');
        }
      }else{
          const modal = document.getElementById('exampleModalAddEmp');
          if (modal) {
            modal.classList.remove('show');
            modal.setAttribute('aria-modal', 'false');
            modal.style.display = 'none';
            document.body.classList.remove('modal-open');
           
          }
        }
    }, [isOpen]);
  return (
     <div className={`modal fade ${isOpen ? 'show' : ''}`} id="exampleModalAddEmp" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden={!isOpen}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              {/* <h5 className="modal-title" id="exampleModalLabel">Confirm</h5> */}
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeModal}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className='z-1 position-relative needs-validation'>
                <div className="form-group">
               <label htmlFor="recipient-name" className="col-form-label">Quiz Level</label>
                    <select
                          required
                          className="form-group form-select"
                          name='quizLevel'
                          value={input.quizLevel}
                          onChange={handleUserInput}
                        >
                          <option value="">-=Level=-</option>
                          <option value={1}>Easy</option>
                          <option value={3}>Hard</option>
                    </select>

                   <label htmlFor="recipient-name" className="col-form-label">Quiz Items</label>
                    <select
                          required
                          className="form-group form-select"
                          name='questionItems'
                          value={input.questionItems}
                          onChange={handleUserInput}
                        >
                          <option value="">-=Items=-</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                    </select>
                </div>
                 <h3>Are you Sure?
                    </h3>
                </div>
                 <div className="modal-footer">
                 {
                 <><button type="submit" className="btn btn-primary" disabled={loading}>Yes</button>
                    <button className="btn btn-secondary" onClick={closeModal}>No</button>
                   </>
              }{
                loading && <Loader/>
              }
            </div>
              </form>
            </div>
           
          </div>
        </div>
      </div>
  )
}

export default ConfirmModal